export default "__VITE_ASSET__BbQyk$Am__"